export default function createIconHTML(
  name: "star" | "star-active" | "star-half-alt-active",
) {
  return `<i class="uil uil-${name}"></i>`;
}
